<template>
    <div class="OrderManageDetail-root">
        <a-tabs type="card" :default-active-key="defaultTab" class="tabs-card" @change="tabChange">
            <a-tab-pane :key="DetailTabs.BASEINFO" tab="基本信息">
                <base-info ref="baseInfo" @changeDetail="changeDetail"></base-info>
            </a-tab-pane>
            <a-tab-pane :key="DetailTabs.CARINFO" tab="派车信息" force-render>
                <car-info ref="carInfo" :is-demo-data="isDemoData"></car-info>
            </a-tab-pane>
        </a-tabs>
        <fix-bottom>
        <template v-if="!onlyGpsPage" slot="button">
            <a-button class="close" @click="closeOrder">
            返回
            </a-button>
        </template>
    </fix-bottom>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FixBottom from '@/components/fix-bottom/index.vue';
import BaseInfo from './BaseInfo.vue'
import CarInfo from './CarInfo'
import {DetailTabs} from '../constant'

export default {
    name: 'OrderManageDetail',
    components: {
        BaseInfo,
        CarInfo,
        FixBottom,
    },
    data () {
        return {
            bottom: 0,
            DetailTabs,
            defaultTab: this.$route.query.detailTab || DetailTabs.BASEINFO,
            isDemoData: false,
        }
    },
    computed: {
      ...mapGetters('iframe', ['onlyGpsPage']),
    },
    created () {},
    mounted () {
      this.$nextTick(()=>{
        if(this.onlyGpsPage) {
          document.getElementsByClassName('affixStyle')[0].style.display='none'
          document.getElementsByClassName('ant-tabs-nav-container')[0].style.display='none'
        }
      })
    },
    beforeDestroy() {
    },
    methods: {
        changeDetail(detail) {
            this.isDemoData = detail.ext?.demoData || false
        },
        tabChange(val){
            if(val === 'car'){
                this.$refs.carInfo.featchData()
            }else{
                this.$refs.baseInfo.getOrderDetail()
            }
        },
        callback(){},
        closeOrder() {
            this.$router.go(-1);
        },
    }
}
</script>

<style lang="less" scoped>
.OrderManageDetail-root {
    padding-bottom: 50px;
}
.affixStyle{
    // width: 100% !important;
    position: fixed;
}
.align-right {
    width: 100%;
    // margin-left: -30px;
    text-align: right;
    height: 50px;
    // background-color: #f0f2f5;
    background-color: #ffffff;
    box-shadow: 0px -5px 5px -5px rgba(0, 0, 0, 0.2);
    padding-top: 10px;
    box-sizing: border-box;
    padding-right: 30px;
    box-sizing: border-box;
    .close{
        margin-right: 30px;
    }
}
/deep/ .ant-table-column-title{
    font-weight: bold;
}
 /deep/ .ant-descriptions-item-label{
    width: 150px !important;
    text-align: right;
  }
</style>

<style lang="less">
.OrderManageDetail-root {
    .ant-descriptions {
        .ant-descriptions-row {
            .ant-descriptions-item-label, .ant-descriptions-item-content {
                padding: 11px 16px;
            }
            .ant-descriptions-item-label {
                color: #606266;
            }
            .ant-descriptions-item-content {
                color: #171717;
            }
        }
    }
}
</style>
